// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"CardsAppB_TheComp__GnDr7"};